/*
  Big-image previous/next arrows for the product page gallery.

  Dawn already knows how to swap the big image — that's what happens when a
  shopper clicks a thumbnail. This file adds two arrows over the big image
  that call exactly the same function, so a shopper can step through the
  photos without going down to the thumbnail strip and back up.

  Nothing in Dawn's own files is changed. The arrows' markup lives in
  snippets/product-media-gallery.liquid; the styling is in
  assets/component-product-gallery-arrows.css.

  Listeners are attached to the document rather than to the buttons, so the
  arrows keep working if Shopify re-renders the gallery (which it does when a
  variant changes).
*/
(function () {
  'use strict';

  function closestEl(node, selector) {
    return node && node.closest ? node.closest(selector) : null;
  }

  // The <ul> holding the photos. Its DIRECT children are the photos — we must
  // never search the whole gallery for [data-media-id], because when the zoom
  // setting is "hover" Dawn puts a second, hidden element carrying the same
  // attribute inside each photo. Counting those made the arrows land on an
  // invisible element and the big image went blank.
  function slideListOf(gallery) {
    return gallery.querySelector('[id^="Slider-Gallery"]');
  }

  function directSlides(gallery) {
    var list = slideListOf(gallery);
    if (!list) return [];
    return Array.prototype.filter.call(list.children, function (el) {
      return el.hasAttribute('data-media-id');
    });
  }

  // The photos in the order the shopper sees them. The thumbnail strip is the
  // best source: it is exactly the list of photos on offer, and it is what
  // Dawn's own thumbnail clicks use. Falls back to the photo list itself for
  // layouts that show no thumbnails.
  function slideIds(gallery) {
    var thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (thumbs) {
      var targets = thumbs.querySelectorAll('[data-target]');
      if (targets.length) {
        return Array.prototype.map.call(targets, function (el) {
          return el.getAttribute('data-target');
        });
      }
    }
    return directSlides(gallery).map(function (el) {
      return el.getAttribute('data-media-id');
    });
  }

  function activeIndex(gallery, ids) {
    var active = directSlides(gallery).filter(function (el) {
      return el.classList.contains('is-active');
    })[0];
    var i = active ? ids.indexOf(active.getAttribute('data-media-id')) : -1;
    return i < 0 ? 0 : i;
  }

  // dir is 1 for next, -1 for previous. Wraps around at both ends so neither
  // arrow is ever a dead button.
  function step(gallery, dir) {
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;
    var ids = slideIds(gallery);
    if (ids.length < 2) return;
    var next = (activeIndex(gallery, ids) + dir + ids.length) % ids.length;
    gallery.setActiveMedia(ids[next], false);
  }

  document.addEventListener('click', function (event) {
    var btn = closestEl(event.target, '[data-gallery-arrow]');
    if (!btn) return;
    // The big image itself opens the zoom pop-up on click — don't let that
    // fire when the shopper is only stepping to the next photo.
    event.preventDefault();
    event.stopPropagation();
    step(closestEl(btn, 'media-gallery'), btn.getAttribute('data-gallery-arrow') === 'next' ? 1 : -1);
  });

  // Left/right keys work too, but only once the shopper has tabbed into the
  // gallery, and never while they're typing in a field.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    var tag = (event.target && event.target.tagName ? event.target.tagName : '').toLowerCase();
    if (tag === 'input' || tag === 'textarea' || tag === 'select') return;
    var gallery = closestEl(event.target, 'media-gallery');
    if (!gallery) return;
    event.preventDefault();
    step(gallery, event.key === 'ArrowRight' ? 1 : -1);
  });
})();
